import React from 'react';
import { Icon } from 'ui';
import { VALIDATION_CONFIG, ValidationType } from './validationConfig';

type ValidationMessageProps = Readonly<{
  children?: React.ReactNode;
  id?: string;
  text?: string;
  type: ValidationType;
}>;

function ValidationMessage({ children, id, text, type }: ValidationMessageProps): JSX.Element {
  const config = VALIDATION_CONFIG[type];

  return (
    <span id={id} className={`validation-message validation-message--${type}`} role='status'>
      <Icon name={config.messageIcon} size="xs" color={config.color} />
      {children || text}
    </span>
  );
}

export default ValidationMessage;
